import { useMutation } from '@tanstack/react-query'
import { useApi } from '@gravitate-js/the-armory'
import { getAPIURL } from '@utils/api'
import type { TrimPayload } from '@components/OrderWizard/Contexts/OrderContainersContext/ProductGroups/api/request'

const endpoints = {
  trimByProduct: 'trailer/compartments/trim_by_product',
}

export const useByProduct = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })
  const trimByProductMutation = useMutation({
    mutationKey: ['trimByProduct'],
    mutationFn: (payload: TrimPayload) => api.post(endpoints.trimByProduct, payload),
  })

  return {
    trimByProductMutation,
  }
}
